module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_1_NL-510033eaa711e11b2e3b856c7913be78.svg";